module.exports = __webpack_public_path__ + "img/hexagon-bry.94e539ad.png";